import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    fees: []
}

const feesSlice = createSlice({
    name: "fees",
    initialState,
    reducers: {
        setFees: (state, action) => {
            state.fees = action.payload;
        },
        removeFees: (state, action) => {
            const { id } = action.payload;
            state.fees = state.fees.filter((item) => item.id !== id);
        }
    }
});

export const { setFees, removeFees } = feesSlice.actions;
export default feesSlice.reducer;